// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { getFileCategory } from '../../config/fileConfig';

export default class AppealHasDocumentsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'publicAppealHasDocuments';
        this.Server = this.props.context.getState().server.publicAppealHasDocuments;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['comment'];

        const defaultHead = [
            {
                id: 'appealId', required: true,
                label: 'appeal',
                alignRight: false,
                cell: 'Select',
                from: 'publicAppeals',
                object: 'appeal',
                show: 'id',
                displayGrid: true
            },
            {
                id: 'fileId',
                label: 'file',
                alignRight: false,
                cell: 'Upload',
                object: 'file',
                fileCategory: getFileCategory('accessible'),
                displayGrid: true
            },
            { id: 'comment', label: 'comment', alignRight: false, cell: 'BigText', displayGrid: true },
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                from: 'users',
                object: 'user',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
